import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';

/**
 * Form Configuration for Add Range Modal
 *
 * Generates the form field configuration for adding a new amount range in the
 * Fulfillment Timeline Dashboard. The configuration adapts based on the selected
 * time unit (minutes or hours).
 *
 * @param {string} timeUnit - The current time unit selected ('minutes' or 'hours')
 * @returns {Array<Object>} Array of form field configurations
 *
 * @example
 * const fields = getAddRangeFormConfig('hours');
 * // Returns field configs with ETA label as "ETA (hours)"
 *
 * const fields = getAddRangeFormConfig('minutes');
 * // Returns field configs with ETA label as "ETA (minutes)"
 */
export const getAddRangeFormConfig = (timeUnit) => [
  {
    name: 'minAmount',
    label: 'Minimum Amount',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: 'number',
    placeholder: 'Enter minimum amount',
    isRequired: true,
    isEditable: true,
    labelColor: 'gray.300',
    value: ''
  },
  {
    name: 'maxAmount',
    label: 'Maximum Amount (leave empty for unbounded)',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: 'number',
    placeholder: 'Enter max amount or leave empty for ∞',
    isRequired: false,
    isEditable: true,
    labelColor: 'gray.300',
    value: ''
  },
  {
    name: 'eta',
    label: `ETA (${timeUnit === 'hours' ? 'hours' : 'minutes'})`,
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: 'number',
    placeholder: `Enter ETA in ${timeUnit === 'hours' ? 'hours' : 'minutes'}`,
    isRequired: true,
    isEditable: true,
    labelColor: 'gray.300',
    value: ''
  }
];
